import { UserDto } from '@act/shared/data-transfer-objects';
import { createSelector } from '@reduxjs/toolkit';
import { selectMembersState } from '../../slices/memberSlice.slice';
import { selectUsersState } from '../../slices/usersSlice.slice';
import { useAppSelector } from '../../storeHooks';

interface utilitySelectorProps {
  id?: string;
  [key: string]: unknown;
}

export const selectUserOrMemberById: (
  state,
  props: utilitySelectorProps
) => UserDto = createSelector(
  [
    selectUsersState,
    selectMembersState,
    (state, props: utilitySelectorProps) => props.id,
  ],
  (users, members, id) => users.entities[id] || members.entities[id] || null
);
export const utilityAppSelectors = {
  selectUserOrMemberById: id =>
    useAppSelector(state => selectUserOrMemberById(state, { id })),
};
